function flattenArray(array) {
  function flattenDown(array, result) {
    for (var i = 0; i < array.length; i++) {
      var value = array[i];

      if (Array.isArray(value)) {
        flattenDown(value, result);
      } else if (value != null && value !== false) {
        result.push(value);
      }
    }

    return result;
  }
  return flattenDown(array, []);
}

export default flattenArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-web/dist/modules/flattenArray/index.js
// module id = 440
// module chunks = 2